import React from 'react';
import { Router } from 'react-router-dom';
import { ChromaProvider } from '@iag-packages/chroma-react/lib/components';
import styled from 'styled-components';
import THEME from 'theme';
import FunnelRouter from 'scenes/FunnelRouter';
import { ContextProvider } from 'scenes/common/contexts/quoteFlowContext';
import ScrollToTop from 'scenes/common/helpers/ScrollToTop';
import history, { initHistory } from 'scenes/common/helpers/history';

import { retrieveReducer } from 'scenes/retrieve/flows';
import { initialRetrieveQuoteState } from 'scenes/retrieve/flows/initialRetrieveQuoteState';
import useRedirect from './scenes/common/hooks/useRedirect';

const AppWrapper = styled.div`
  background-color: ${THEME.BACKGROUND.WHITE};
`;

function App() {
  useRedirect();
  initHistory();
  return (
    <AppWrapper>
      <Router history={history}>
        <ScrollToTop />
        <ContextProvider
          initialFunnelState={initialRetrieveQuoteState}
          reducer={retrieveReducer}
        >
          <ChromaProvider>
            <FunnelRouter />
          </ChromaProvider>
        </ContextProvider>
      </Router>
    </AppWrapper>
  );
}

export default App;
